import * as React from 'react';
import { featuresSmall } from '../../contents';
import { FeaturesSmall } from '../features-small';
import { SectionCommon } from '../layout/section-common';

export const Services = () => (
	<SectionCommon
		title="4 Services Under 1 Roof"
		text=" Gain efficiency and synergy with our convenient, one-stop white label services."
	>
		<FeaturesSmall features={featuresSmall} />	
	</SectionCommon>
);